<template>

  <!-- Modal component -->
  <modal :show.sync="showModal" >
    <color-picker :color.sync="user.color" ></color-picker>
  </modal>

    <div class="card card-content">
        <div class="card-header">
            <div class="header">
              <breadcrumb :current="name"></breadcrumb>
                <h1>Modifier un utilisateur</h1>
            </div>
            <div class="actions">
                <a class="btn btn-link" v-link="{ path: '/administration'}" >Voir tous les utilisateurs</a>
                <button class="btn btn-link" @click="saveUser" :class="{ inactive: $userValidation.invalid }">Sauvegarder les modifications</button>
            </div>
        </div>
        <div class="card-block">
            <validator name="userValidation">

                <form novalidate>
                    <fieldset>
                        <legend>Mettre à jour les données utilisateur</legend>
                        <!-- Username -->
                        <div class="form-group" >
                            <label for="username">Nom d'utilisateur</label>
                            <input class="form-control"
                                    id                  = "username"
                                    type                = "text"
                                    v-model             = "user.username"
                                    v-validate:username = "validationRules.username"
                            >
                        </div>

                        <!-- Email address -->
                        <div class="form-group" >
                            <label for="email">Adresse email</label>
                            <input class="form-control"
                                    id               = "email"
                                    type             = "text"
                                    v-model          = "user.email"
                                    v-validate:email = "validationRules.email"
                            >
                        </div>

                        <!-- First name -->
                        <div class="form-group" >
                            <label for="firstname">Prénom</label>
                            <input class="form-control"
                                    id                   = "firstname"
                                    type                 = "text"
                                    v-model              = "user.firstname"
                                    v-validate:firstname = "validationRules.firstname"
                            >
                        </div>

                        <!-- Last name -->
                        <div class="form-group" >
                            <label for="lastname">Nom</label>
                            <input class="form-control"
                                    id                  = "lastname"
                                    type                = "text"
                                    v-model             = "user.lastname"
                                    v-validate:lastname = "validationRules.lastname"
                            >
                        </div>



                        <!-- Color -->
                        <div class="form-group" >
                            <label for="color">Couleur</label>
                            <span
                                    id               = "color"
                                    type             = "text"
                                    class            = "colorpicker"
                                    :style           = "'background-color: ' + user.color "
                                    diabled          = "true"
                                    @click.prevent   = "modalColor()"
                            >
                            </span>
                        </div>

                        <!-- Phone number -->
                        <div class="form-group" >
                            <label for="phone">Numéro de téléphone</label>
                            <input class="form-control"
                                    id               = "phone"
                                    type             = "text"
                                    v-model          = "user.phone"
                                    v-validate:phone = "validationRules.phone"
                            >
                        </div>

                    </fieldset>

                </form>

                <form novalidate>
                    <fieldset>
                        <legend>Mettre à jour le mot de passe (laisser vide pour garder le mot de passe actuel)</legend>
                        <!-- Password -->
                        <div class="form-group" >
                            <label for="password">Mot de passe</label>
                            <input class="form-control"
                                    id                  = "password"
                                    type                = "password"
                                    v-model             = "user.password"
                                    v-validate:password = "validationRules.password"
                            >
                        </div>

                        <!-- Password confirmation -->
                        <div class="form-group" >
                            <label for="password_confirmation">Retapez le mot de passe</label>
                            <input class="form-control"
                                    id                              = "password_confirmation"
                                    type                            = "password"
                                    v-model                         = "user.password_confirmation"
                                    v-validate:passwordConfirmation = "validationRules.passwordConfirmation"
                            >
                        </div>
                    </fieldset>
                </form>

                <!-- Errors -->
                <div v-if="$userValidation.errors" >
                    <hr>
                    <ul>
                        <li class="errors" v-for="error in $userValidation.errors" >{{ error.message }}</li>
                    </ul>
                </div>
            </validator>
        </div>
        <div class="card-footer">
            <div class="actions">
                <a class="btn btn-link" v-link="{ path: '/administration'}" >Voir tous les utilisateurs</a>
                <button class="btn btn-link" @click="saveUser" :class="{ inactive: $userValidation.invalid }">Sauvegarder les modifications</button>
            </div>
        </div>
    </div>
</template>

<script>
import { user as currentUser } from '../../vuex/getters'
import { edit as validationRules } from 'src/validations/user.js'
import { getUser, editUser } from 'src/vuex/actions/userActions'
import { validateUsername, validateEmail, validateHex, validatePhone } from 'src/validations/customRules.js'

// Notifications message
import toastr from 'toastr'

import Modal from 'src/components/modals/Modal.vue'
import ColorPicker from 'src/components/modals/ColorPicker.vue'
import Breadcrumb from '../nav/Breadcrumb.vue'

export default{
  vuex: {
    getters: { currentUser, userUpdated: ({ users }) => users.userUpdated },
    actions: { getUser, editUser }
  },
  validators: {
    validateHex,
    validateEmail,
    validatePhone,
    validateUsername,
    passwordMatch (val) {
      return this.vm.user.password === val
    }
  },
  data () {
    return {
      user: {},
      validationRules,
      showModal: false
    }
  },
  components: { ColorPicker, Modal, Breadcrumb },
  methods: {
    modalColor () { this.showModal = true },
    saveUser () { this.editUser(this.currentUser, this.user) }
  },
  watch: {
    'user.password' (value) {
      if (value === '') {
        this.user.password = undefined
        this.user.password_confirmation = undefined
      }
    },
    'userUpdated' (value) {
      if (value === true) {
        toastr.success("L'utilisateur a bien été modifié")
      }
    }
  },
  computed: {
    name: function () {
      if (this.user) {
        return this.user.firstname + ' ' + this.user.lastname
      }
    }
  },
  ready () {
    let vm = this
    this.getUser(this.$route.params.userId)
      .then(() => { vm.user = JSON.parse(JSON.stringify(vm.currentUser)) })
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// UserEdit.vue?7710d0a8